
import Vue from 'vue'
import ShareQrcode from './ActivityShareQrcode.vue'

let shareQrcodeInstance
const ShareQrcodeConstructor = Vue.extend(ShareQrcode) // 使用extend方法创建类似Vue的构造函数
const shareQrcode = function(options = {}) {
  shareQrcodeInstance = new ShareQrcodeConstructor({
    data: options
  })
  document.body.appendChild(shareQrcodeInstance.$mount().$el)
  const appInstance = document.body.querySelector('#app') as Element
  appInstance.classList.add('privacy-masking')
}

export default shareQrcode
